import { render, staticRenderFns } from "./contentEdit.vue?vue&type=template&id=0a0e8454&scoped=true&"
import script from "./contentEdit.vue?vue&type=script&lang=js&"
export * from "./contentEdit.vue?vue&type=script&lang=js&"
import style0 from "./contentEdit.vue?vue&type=style&index=0&id=0a0e8454&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0e8454",
  null
  
)

export default component.exports